module.exports = __webpack_public_path__ + "static/media/pencil_highlight.db8ba1e7.svg";